<template>
    <v-dialog
        ref="bindMobDialog"
        :open="show"
        :title="title"
        @input="handleToggleDialogVisiable"
        :kind="kind"
        :status="status"
        :class="{'user-bind-tel-step0' : step === 0}"
        class="user-bind-tel-dialog"
    >
        <div
            v-if="showTitle"
            :style="{marginBottom: '30px'}"
        >
            <span v-if="isChangeTel && !verPreMobSuc">验证当前登录账号的手机验证码，若无法使用旧手机，请联系<br>管理员解绑</span>
            <span v-else>{{
                '绑定后可使用手机号登录企点'
            }}</span>
        </div>
        <div class="body">
            <v-form
                ref="form"
                v-if="step === 0"
                @submit.prevent="checkoutTel"
                class="form"
                kind="desc"
            >
                <v-form-item
                    :rules="isChangeTel && !verPreMobSuc ? [] : formRules.mobile"
                    name="mobile"
                    error-placement="bottom-left"
                    label="手机号"
                    required="请输入手机号"
                >
                    <v-input
                        ref="internationalTelInput"
                        v-if="isChangeTel && !verPreMobSuc"
                        :value="mobileChange"
                        :width="294"
                        :disabled="isChangeTel && !verPreMobSuc"
                        :clearable="false"
                        class="demo-default-input"
                        placeholder="请输入手机号"
                        autofocus
                    />
                    <v-input
                        ref="internationalTelInput"
                        v-else
                        v-model="form.mobile"
                        :width="294"
                        :clearable="false"
                        class="demo-default-input"
                        placeholder="请输入手机号"
                        autofocus
                    />
                </v-form-item>
                <v-form-item
                    :rules="formRules.sms_code"
                    name="sms_code"
                    error-placement="bottom-left"
                    label="验证码"
                    required="请输入验证码"
                    class="input_sms_code"
                >
                    <div class="sms_code-input-wrap">
                        <v-input
                            v-model="form.sms_code"
                            :width="184"
                            class="sms_code-input"
                        />
                        <v-button
                            :disabled="isCountdown || !form.mobile || (isChangeTel && mobileChange === mobile)"
                            :loading="sendCaptchaLoading"
                            @click="sendCaptcha"
                            class="captch-btn"
                        >
                            {{ isCountdown ? `${countdown}s` : '获取验证码' }}
                        </v-button>
                    </div>
                </v-form-item>
                <v-form-item
                    class="btn-item"
                >
                    <v-footer-actionbar
                        :divider="false"
                        @cancel="$refs.bindMobDialog.handleClose($event)"
                        :layout="{
                            primary: {
                                loading: bindStatusLoading || bindLoading,
                                type: 'submit',
                                text: '确定',
                            },
                            cancel: {
                                text: '取消',
                            }
                        }"
                        size="large"
                    />
                </v-form-item>
            </v-form>
            <div
                v-else-if="step === 1"
                class="tip-box-step1"
            >
                <div class="tip-description">
                    <span>
                        您当前登录帐号存在其他绑定关系，只能绑定新手机号<br>
                        详细内容请点击<a
                            href="/hp/helpCenter/index"
                            target="_blank"
                        >前往帮助中心</a>查看
                    </span>
                </div>
                <div class="btn-row">
                    <v-button
                        @click="resetForm"
                        status="warning"
                        size="large"
                        style="margin-right:20px;"
                    >
                        重新输入手机号
                    </v-button>
                    <v-button
                        @click="resetForm"
                        status="default"
                        size="large"
                    >
                        返回
                    </v-button>
                </div>
            </div>
            <div
                v-else-if="step === 2"
                class="tip-box-step2"
            >
                <div class="tip-description">
                    <span>
                        您当前登录帐号存在其他绑定关系，只能绑定新手机号<br>
                        详细内容请点击<a
                            href="/hp/helpCenter/index"
                            target="_blank"
                        >前往帮助中心</a>查看
                    </span>
                </div>
                <div class="btn-row">
                    <v-button
                        @click="step = 0"
                        status="primary"
                        size="large"
                        style="margin-right:12px;"
                    >
                        重新输入手机号
                    </v-button>
                    <v-button
                        @click="step = 0"
                        status="default"
                        size="large"
                    >
                        取消
                    </v-button>
                </div>
            </div>
            <div
                v-else-if="step === 3"
                class="tip-box-step3"
            >
                <div class="tip-description">
                    <span>
                        您当前登录帐号存在其他绑定关系，已经关联过
                        <span
                            v-for="(item, index) in showAidList"
                            :key="index"
                        >
                            <span>{{ item.corp_short_name }}<span v-if="index !== showAidList.length - 1">、</span>
                            </span>
                            <br v-if="index === 0">
                        </span>
                        下的员工帐号，是否继续关联当前帐号
                    </span>
                </div>
                <div class="btn-row">
                    <v-button
                        :loading="bindLoading"
                        @click="handleFormSubmit"
                        status="primary"
                        style="margin-right:12px;"
                        size="large"
                    >
                        继续关联
                    </v-button>
                    <v-button
                        @click="step = 0"
                        status="default"
                        size="large"
                    >
                        重新输入手机号
                    </v-button>
                </div>
            </div>
            <div
                v-else-if="step === 4"
                class="tip-box-step4"
            >
                <div class="tip-description">
                    <p>当前账号与手机号 {{ form.mobile | encryptTel }} 关联成功</p>
                </div>
                <div class="btn-row">
                    <v-button
                        @click="$emit('update:show', false)"
                        size="large"
                    >
                        知道了
                    </v-button>
                </div>
            </div>
            <div
                v-else-if="step === 5"
                class="tip-box-step5"
            >
                <div class="tip-description">
                    <p>当前账号与手机号 {{ form.mobile | encryptTel }} 绑定成功</p>
                </div>
                <div class="btn-row">
                    <v-button
                        @click="() => {$emit('update:show', false); open = false;}"
                        size="large"
                    >
                        知道了
                    </v-button>
                </div>
            </div>
        </div>
        <div slot="footer" />
    </v-dialog>
</template>

<script>
/* eslint-disable max-len */
import { encryptTel } from '@/components/international-tel-input/utils';
import { customerReport } from 'src/utils/QidianMonitor';
import Gateway from '@/utils/Gateway';

const CHECK_MSG_URL = '/v1/basic.account.account_web.Account/CheckVerifyCodeV2';
const GET_AID_URL = '/v1/basic.account.account_web.Account/AidByPhoneV2';
// const CHECK_BIND_URL = '/v1/basic.account.account_web.AccountWeb/GetBindAccount'; // 验证个人资料手机
// const CHECK_LOGIN_URL = '/v1/basic.account.account_web.AccountWeb/GetLoginMobileAccount'; // 验证登录管理手机
const BIND_TEL = '/v1/basic.account.account_web.Account/BindMobileV2'; // 绑定手机
const UPDATE_BIND_TEL = '/v1/basic.account.account_web.Account/ModifyMobile'; // 换绑手机
const LNIK_TEL = '/v1/basic.account.account_web.AccountWeb/LinkMobile'; // 关联手机
// const BIND_LOGIN_TEL = '/v1/basic.account.account_web.AccountWeb/BindLoginMobile'; // 绑定登录手机
const GET_CAPTCHA = '/v1/basic.account.account_web.AccountWeb/SendLoginMSG'; // 发送验证码
const GET_CAPTCHA_FOR_OLD = '/v1/basic.account.account_web.Account/SendSelfSMS'; // 换绑发送验证码
const DEFAULT_FORM = {
    mobile: '',
    sms_code: '',
    is_sync_login: false,
    bind_type: 0,
};
const COUNT_DOWN_INIT = 60;
export default {
    filters: {
        encryptTel,
        encryptAid(aid) {
            const tell = /(\d{3})\d*(\d{4})/;
            return aid.replace(tell, '$1****$2');
        },
    },
    props: {
        isChangeTel: {
            type: Boolean,
            default: false,
        },
        isMobileLink: {
            type: Boolean,
            default: false,
        },
        isCheckSync: {
            type: Boolean,
            default: false,
        },
        account: {
            type: String,
            default: '',
        },
        mobile: {
            type: String,
            default: '',
        },
        from: {
            type: String,
            default: 'person-info',
        },
        show: {
            typeof: Boolean,
            default: true,
        },
        aid: {
            type: String,
            required: true,
        },
        isPrivate: {
            type: Boolean,
            default: false,
        },
        syncBind: {
            type: Boolean,
            default: false,
        },
        showSyncBind: {
            type: Boolean,
            default: false,
        },
        isInWhiteList: {
            type: Boolean,
            default: false,
        },
        hasCheckPhone: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const vm = this;
        return {
            aidList: [],
            filterAidList: [],
            form: {
                ...DEFAULT_FORM,
                mobile: this.isChangeTel ? '' : this.mobile || '',
                is_sync_login: this.isCheckSync,
                bind_type: this.isMobileLink ? 1 : 0,
            },
            step: 0,
            bindLoading: false,
            bindStatusLoading: false,
            countdown: COUNT_DOWN_INIT,
            hasBindAccount: '',
            countdownTimer: null,
            sendCaptchaLoading: false,
            tipType: 0, // 0: 绑定个人资料抢占情况 1: 绑定登录方式出现抢占的情况
            bindKfext: null,
            verPreMobSuc: false,
            formRules: {
                mobile: [
                    {
                        require: true,
                        message: '手机号不能为空',
                        trigger: 'submit',
                    },
                    {
                        validate(value) {
                            return value !== vm.mobile;
                        },
                        message: '该手机号已绑定当前账户，请输入新的手机号',
                        trigger: 'change',
                    },
                    {
                        validate(value) {
                            return /^1(?:\d){10}$/.test(value);
                        },
                        message: '手机号格式不正确',
                        trigger: 'change',
                    },
                    {
                        validate(value) {
                            return /^1(?:\d){10}$/.test(value);
                        },
                        message: '手机号格式不正确',
                        trigger: 'submit',
                    },
                ],
                sms_code: [
                    {
                        required: true,
                        message: '验证码不能为空',
                        trigger: 'submit',
                        trim: false,
                    },
                    {
                        validate(value) {
                            return /^\d{6}$/.test(value);
                        },
                        message: '验证码格式错误',
                        trigger: 'submit',
                    },
                ],
            },
            preCheckCode: '',
        };
    },
    computed: {
        mobileChange() {
            if (this.isChangeTel && !this.verPreMobSuc) {
                return this.form.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
            }
            return this.form.mobile;
        },
        showAidList() {
            const len = this.filterAidList.length;
            if (len > 1) {
                return [
                    this.filterAidList[0],
                    this.filterAidList[1],
                ];
            } if (len === 1) {
                return [
                    this.filterAidList[0],
                ];
            }
            return [];
        },
        showTitle() {
            return this.step === 0;
        },
        isCountdown() {
            return this.countdown < COUNT_DOWN_INIT;
        },
        isFromPersonInfo() {
            return this.from === 'person-info';
        },
        title() {
            if (this.isChangeTel && this.step === 0) {
                if (this.verPreMobSuc) return '验证成功，绑定新手机号';
                return '验证原手机号';
            }
            if (this.showTitle && this.step === 0) {
                return '绑定手机号';
            }
            if (this.step === 1) {
                return '绑定失败，该手机号已绑定其他帐号';
            }
            if (this.step === 2) {
                return '该手机号关联的员工账号已达上限';
            }
            if (this.step === 3) {
                return '该手机号已关联过其它帐号，是否继续关联';
            }
            if (this.step === 4) {
                return '关联成功';
            }
            if (this.step === 5) {
                return '绑定成功';
            }
            return '';
        },
        kind() {
            if (this.step === 0) {
                return 'alert';
            }
            return 'alert';
        },
        status() {
            if (this.step === 0) {
                return 'default';
            } if (this.step === 1) {
                return 'warning';
            } if (this.step === 2 || this.step === 3) {
                return 'primary';
            }
            return 'success';
        },
    },

    watch: {
        hasCheckPhone(val) {
            this.verPreMobSuc = val;
        },
    },
    created() {
        this.verPreMobSuc = this.hasCheckPhone ? this.hasCheckPhone : this.verPreMobSuc;
        this.form.mobile = this.isChangeTel ? this.mobile : '';
    },

    mounted() {
        customerReport({
            name: '手机绑定流程',
            ext1: 'show',
        });
    },

    methods: {
        handleToggleDialogVisiable(visiable) {
            this.$emit('update:show', visiable);
        },
        handleLinkAccount(isBind = false) {
            this.bindLoading = true;
            const { form } = this;
            Gateway.post(LNIK_TEL, form)
                .then(() => {
                    this.bindLoading = false;
                    this.$emit('on-bind-success');
                    this.step = isBind ? 5 : 4;

                    customerReport({
                        name: '手机绑定流程',
                        ext1: 'req LinkMobile success',
                    });
                })
                .catch((err) => {
                    this.$message.error(err || '网络故障，请稍后再试');
                    this.bindLoading = false;

                    customerReport({
                        name: '手机绑定流程',
                        ext1: 'req LinkMobile fail',
                        ext2: JSON.stringify({ message: err }),
                    });

                    throw err;
                });
        },
        bindStatus(res) {
            const { code, message } = res;
            this.bindLoading = false;
            if (code === 200031) {
                this.step = 1;
            } else if (code === 200029) {
                this.step = 2;
            } else {
                this.$message.error(message || '绑定失败');
            }
        },
        handleFormSubmit() {
            this.bindLoading = true;
            const { form } = this;
            const params = this.isChangeTel ? {
                mobile: form.mobile,
                sms_code: form.sms_code,
                code: this.preCheckCode,
            } : {
                mobile: form.mobile,
                sms_code: form.sms_code,
            };
            return new Promise((resolve, reject) => {
                this.$ajax.gatewayPost(this.isChangeTel ? UPDATE_BIND_TEL : BIND_TEL, params, {customFn: this.bindStatus})
                    .then((res) => {
                        this.bindLoading = false;
                        const { code } = res;
                        if (code === 0) {
                            this.step = 5;
                            this.$emit('on-bind-success');
                        }
                        resolve();

                        customerReport({
                            name: '手机绑定流程',
                            ext1: 'req BindMobile success',
                        });
                    })
                    .catch((err) => {
                        this.$message.error(err || '网络故障，请稍后再试');
                        this.bindLoading = false;
                        reject();
                        customerReport({
                            name: '手机绑定流程',
                            ext1: 'req BindMobile fail',
                            ext2: JSON.stringify({ message: err }),
                        });

                        throw err;
                    });
            });
        },
        startCountdown() {
            /* eslint-disable no-plusplus */
            this.countdown--;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= -1) {
                    this.clearCountdownTimer();
                    this.countdown = COUNT_DOWN_INIT;
                }
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearCountdownTimer);
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
        },
        sendCaptcha() {
            // 如果手机号码不合法，则不能获取验证码
            if (!/^1(?:\d){10}$/.test(this.form.mobile)) {
                return;
            }
            this.sendCaptchaLoading = true;
            const useUrlForOld = this.isChangeTel && !this.verPreMobSuc;
            const form = useUrlForOld ? {} : {
                mobile: this.form.mobile,
                type: 1,
            };
            Gateway.post(useUrlForOld ? GET_CAPTCHA_FOR_OLD : GET_CAPTCHA, form)
                .then(() => {
                    // data.code = 1003 [1003]验证码发送频繁，请稍后再试
                    this.startCountdown();
                    this.sendCaptchaLoading = false;

                    customerReport({
                        name: '手机绑定流程',
                        ext1: 'req SendLoginMSG success',
                    });
                })
                .catch((err) => {
                    this.sendCaptchaLoading = false;
                    this.$message.error(err || '网络故障，请稍后再试');

                    customerReport({
                        name: '手机绑定流程',
                        ext1: 'req SendLoginMSG fail',
                        ext2: JSON.stringify({ message: err }),
                    });

                    throw err;
                });
        },
        async checkoutTel() {
            // this.form.is_sync_login ? this.checkoutLoginManageTel() : this.checkoutPersonInfoTel();
            // 如果是个人资料绑定手机或者在登录管理绑定手机，勾选了同步手机号到个人资料，则需要检查手机号是否已经被绑
            // 主要手机在个人资料进行绑定，需要校验手机号的绑定情况，登录管理绑定手机号不需要校验
            // 如果是更换号码，直接覆盖
            if (this.isChangeTel) {
                this.verPreMobSuc ? await this.handleFormSubmit() : await this.checkoutPreMobile();
            } else {
                await this.getAidlist();
            }
        },
        checkoutPreMobile() {
            return new Promise((resolve, reject) => {
                this.$ajax.gatewayPost(CHECK_MSG_URL, { mobile: this.form.mobile, sms_code: this.form.sms_code })
                    .then((res) => {
                        if (res && res.code === 0) {
                            this.$message.success('手机验证成功');
                            this.bindLoading = false;
                            this.verPreMobSuc = true;
                            this.form.mobile = '';
                            this.form.sms_code = '';
                            this.preCheckCode = res.data && res.data.code;
                            this.step = 0;
                            this.clearCountdownTimer();
                            this.countdown = COUNT_DOWN_INIT;
                            resolve();
                        } else {
                            this.bindLoading = false;
                            this.$message.error(res.message || '网络故障，请稍后再试');
                            reject();
                        }

                        customerReport({
                            name: '手机绑定流程',
                            ext1: 'req GetBindAccount success',
                            ext2: JSON.stringify(res && res.code),
                        });
                    })
                    .catch((err) => {
                        this.bindLoading = false;
                        this.$message.error(err.message || '网络故障，请稍后再试');
                        reject();

                        customerReport({
                            name: '手机绑定流程',
                            ext1: 'req GetBindAccount fail',
                            ext2: JSON.stringify({ message: err }),
                        });

                        throw err;
                    });
            });
        },
        getAidlist() {
            return new Promise((resolve, reject) => {
                this.$ajax.gatewayPost(GET_AID_URL, { phone_number: this.form.mobile, sms_code: this.form.sms_code }).then(async (res) => {
                    if (res && res.code === 0) {
                        this.aidList = (res.data && res.data.aid_corp_info) || [];
                        resolve();
                        if (this.aidList.length) {
                            this.aidList.forEach((item) => {
                                const hasCorp = this.filterAidList.filter(cur => item.corp_id === cur.corp_id);
                                if (!hasCorp.length) {
                                    this.filterAidList.push(item);
                                }
                            });
                            this.step = 3;
                        } else {
                            await this.handleFormSubmit();
                        }
                    } else {
                        reject();
                        this.$message.error(res.message || '网络故障，请稍后再试');
                    }
                })
                    .catch((err) => {
                        reject();
                        this.bindLoading = false;
                        this.$message.error(err.message || '网络故障，请稍后再试');
                    });
            });
        },
        resetForm() {
            this.form = {
                ...DEFAULT_FORM,
                mobile: this.mobile,
                is_sync_login: this.isInWhiteList ? false : this.isCheckSync, // 因为不在白名单需要隐藏单选框，所以需要在这里将其强制为false
                bind_type: this.isMobileLink ? 1 : 0,
            };
            this.clearCountdownTimer();
            this.countdown = COUNT_DOWN_INIT;
            this.hasBindAccount = '';
            this.step = 0;
        },
        handleBindCurrentCount() {
            this.handleFormSubmit(false);
        },
    },
};
</script>

<style lang="less" scoped>
.form {
    .btn-item {
        margin-bottom: 0;

        /deep/ .v-description-item--value {
            padding-bottom: 0;
        }
    }
    /deep/ .v-description-item {
        margin-right: 0;
        margin-left: 0;
    }

    /deep/ .v-description-item--horizontal {
        width: 392px !important;
    }

    /deep/ .v-descriptions--content {
        right: 0;
        width: 392px;
    }
    .sms_code-input-wrap {
        display: inline-flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        .captch-btn {
            position: relative;
            top: -3px;
        }
    }

    .input_sms_code {
        /deep/ .v-description-item--text-content {
            width: 90px;
        }

        .captch-btn {
            margin-left: 4px;
            min-width: 102px !important;
            font-size: 14px;
        }

        .sms_code-input {
            vertical-align: bottom;
        }

        /deep/ .v-input {
            vertical-align: bottom;
        }
    }

    /deep/.v-input--main {
        text-align: left;
    }

    /deep/.v-footer-actionbar-center {
        width: 392px;
    }

    /deep/.v-footer-actionbar {
        padding : 0;
    }

}
.user-bind-tel-step0 {
    /deep/.v-dialog__footer {
        display: none;
    }
    /deep/.v-dialog__body {
        padding-bottom: 0;
    }
}
.user-bind-tel-dialog {
    .v-dialog__footer {
        display: none;
    }
    /deep/.v-dialog__body {
        padding-bottom: 0;
        padding-top: 8px;
    }
    // .v-dialog__content {
    //     padding: 40px 0;
    //     width: 440px;
    // }
    .body {
        // padding: 15px 40px;
        .form {
            // margin-bottom: -10px;
            // .form-label {
            //     margin-right: 15px;
            // }
            // .captch-btn {
            //     right: -112px;
            //     position: absolute;
            // }
            // .btn-item {
            //     .v-form-item__input {
            //         width: 100%;
            //         float: none;
            //     }
            // }
        }
        .tip-box-step1 {
            /deep/.v-button {
                min-width: 90px;
                font-weight: 500;
                font-size: 14px;
            }
            // margin-top: -70px;
            // margin-bottom: -32px;
            // .tip-icon {
            //     width: 40px;
            //     height: 40px;
            //     background: url('../../assets/ic_warning@2x.png') no-repeat;
            //     background-size: cover;
            //     margin: 0 auto;
            // }
            // .tip-text {
            //     margin-top: 20px;
            //     font-size: 24px;
            //     line-height: 33px;
            //     color: #1e2330;
            //     text-align: center;
            //     word-break: break-all;
            // }
            // .tip-description {
            //     margin-top: 8px;
            //     color: #a8abb3;
            //     line-height: 20px;
            //     font-size: 14px;
            //     span {
            //         word-break: break-all;
            //     }
            // }

            // .blue {
            //     font-size: 14px;
            //     color: #0067ed;
            // }

            .btn-row {
                margin-top: 24px;
            }
            // .extra-tip {
            //     font-size: 12px;
            //     line-height: 17px;
            //     color: #a8abb3;
            //     cursor: pointer;
            //     margin-top: 5px;
            //     text-align: left;
            // }
        }
        .tip-box-step2 {
            .v-button {
                min-width: 90px;
                font-weight: 500;
                font-size: 14px;
            }
            // margin-top: -70px;
            // margin-bottom: -10px;
            // .tip-icon {
            //     width: 40px;
            //     height: 40px;
            //     background: url('../../assets/ic_warning@2x.png') no-repeat;
            //     background-size: cover;
            //     margin: 0 auto;
            // }
            // .tip-text {
            //     margin-top: 20px;
            //     font-size: 24px;
            //     line-height: 33px;
            //     color: #1e2330;
            //     text-align: center;
            //     word-break: break-all;
            // }
            .tip-description {
                margin-top: 8px;
                color: #a8abb3;
                line-height: 20px;
                font-size: 14px;
                span {
                    word-break: break-all;
                }
            }

            .btn-row {
                margin-top: 24px;
            }
        }
        .tip-box-step3 {
            /deep/.v-button {
                min-width: 90px;
                font-weight: 500;
                font-size: 14px;
            }
            // margin-top: -95px;
            // margin-bottom: -10px;
            // .tip-icon {
            //     width: 40px;
            //     height: 40px;
            //     background: url('../../assets/ic_warning@2x.png') no-repeat;
            //     background-size: cover;
            //     margin: 0 auto;
            // }
            // .tip-text {
            //     margin-top: 20px;
            //     font-size: 24px;
            //     line-height: 33px;
            //     color: #1e2330;
            //     text-align: center;
            //     word-break: break-all;
            // }
            .tip-description {
                margin-top: 8px;
                color: #a8abb3;
                line-height: 20px;
                font-size: 14px;
                span {
                    word-break: break-all;
                }
            }
            .btn-row {
                margin-top: 50px;
            }
        }
        .tip-box-step4 {
            .v-button {
                min-width: 90px;
                font-weight: 500;
                font-size: 14px;
            }
            // margin-top: -70px;
            // margin-bottom: -10px;
            // .tip-icon {
            //     width: 40px;
            //     height: 40px;
            //     background: url('../../assets/check@2x.png') no-repeat;
            //     background-size: cover;
            //     margin: 0 auto;
            // }
            // .tip-text {
            //     margin-top: 20px;
            //     font-size: 24px;
            //     line-height: 33px;
            //     color: #1e2330;
            //     text-align: center;
            //     word-break: break-all;
            // }
            // .tip-description {
            //     margin-top: 8px;
            //     color: #a8abb3;
            //     line-height: 20px;
            //     font-size: 14px;
            //     span {
            //         word-break: break-all;
            //     }
            // }

            .btn-row {
                margin-top: 24px;
            }
        }
        .tip-box-step5 {
            /deep/.v-button {
                min-width: 90px;
                font-weight: 500;
                font-size: 14px;
            }
            // margin-top: -70px;
            // margin-bottom: -10px;
            // .tip-icon {
            //     width: 40px;
            //     height: 40px;
            //     background: url('../../assets/check@2x.png') no-repeat;
            //     background-size: cover;
            //     margin: 0 auto;
            // }
            // .tip-text {
            //     margin-top: 20px;
            //     font-size: 24px;
            //     line-height: 33px;
            //     color: #1e2330;
            //     text-align: center;
            //     word-break: break-all;
            // }
            // .tip-description {
            //     margin-top: 8px;
            //     color: #a8abb3;
            //     line-height: 20px;
            //     font-size: 14px;
            //     span {
            //         word-break: break-all;
            //     }
            // }

            .btn-row {
                margin-top: 24px;
            }
        }
    }
}
</style>
